//----------------------------------------------------------------------------------model
const model = () => ({
  email: undefined,
});

//-------------------------------------------------------------------------------------------actions
const CHANGE_USER_EMAIL = '@@user/CHANGE_USER_EMAIL';

//------------------------------------------------------------------------------------------creators

export const changeUserEmail = value => ({
  type: CHANGE_USER_EMAIL,
  payload: { value },
});

//--------------------------------------------------------------------------------reducer
export default (state = model(), action = {}) => {
  switch (action.type) {
    case CHANGE_USER_EMAIL:
      return { ...state, email: action.payload.value };
    default:
      return state;
  }
};
